import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import * as moment from 'moment';

@Component({
  selector: 'app-me-perfil-editar',
  templateUrl: './me-perfil-editar.component.html',
  styleUrls: ['./me-perfil-editar.component.css']
})
export class MePerfilEditarComponent implements OnInit, OnDestroy {

  hideCL: boolean = false;
  titEdit: any = '';
  arrModalidades: any[] = [];
  arrConquistas: any[] = [];
  urlFoto: any = '';
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router,  public tmaService: TamasAlunoService) { }

  ngOnInit() {
    this.tmaService.eventoFS(true);
    this.hideCL = true;
    const tipoEdit = this.route.snapshot.paramMap.get('tipoedit');
    this.titEdit = tipoEdit;
    if(tipoEdit == 'modalidades' || tipoEdit == 'conquistas' ){
      console.log(tipoEdit);
      this.listarDadosComp(this.tmaService.hcNomeUsuario, tipoEdit);
    }
    else{
      this.router.navigate(["/me/perfil"]);
    }
  }
  ngOnDestroy(){
    console.log("destroy");
    this.tmaService.eventoFS(false);
  }

  listarDadosComp(qUsuario : any, qTipoDetail) :void{
    //parte do servidor
    this.hideCL = false;
    var dadosIn = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&usuario=' + qUsuario + '&tipodado=' + qTipoDetail + '&meuindex=0';
    this.tmaService.listarDadosPerfil(dadosIn)
    .subscribe((qRes) =>{
      console.log(qRes);
      if(qRes['res'] == 'done'){
        if(qTipoDetail == 'modalidades'){
          this.arrModalidades = qRes['arrResultado'];
          this.tmaService.mModalidades = qRes['arrResultado'];
          this.tmaService.mModLoaded = true;
          this.urlFoto = this.tmaService.urlRepositorioS3 + "/users-conquest/";
        }
        if(qTipoDetail == 'conquistas'){
          this.arrConquistas = qRes['arrResultado'];
          this.arrConquistas.forEach((item, index) => {
            this.arrConquistas[index].data = moment(item.data).format('DD/MM/YYYY');
          });
          this.urlFoto = this.tmaService.urlRepositorioS3 + "/users-conquest/";
        }
      }
      this.hideCL = true;
    })
  } 


  excluirModal(idModalidade: any): void{
    this.hideCL = false;
    console.log(idModalidade);
    var dadosIn = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idmodal=' + idModalidade;
    this.tmaService.removeModalidade(dadosIn)
    .subscribe((qRes) =>{
      console.log(qRes);
      if(qRes['res'] == 'done'){
        var idxMod = this.arrModalidades.findIndex(x => x.id == idModalidade);
        this.arrModalidades.splice(idxMod, 1);
        this.hideCL = true;
      }
    });
  }

  goInserir(qTipo : any) :void{
    this.router.navigate(["/me/perfil/add/" + qTipo]);
  }

  voltar() :void{
    if(this.tmaService.gUrlAnterior == 'perfil'){
      this.router.navigate(["/me/perfil"]);
    }
    else{
      this.router.navigate(["/home/1"]);
    }
    
  }


}
